'use client'

import {observer} from 'mobx-react'

import {Routes} from '@/src/config/routes'
import {PageType} from '@/src/core/domain/entities/page'

import {CatalogFiltersMobileBtn} from '@/src/features/catalog/filters-v2/ui/mobile-filters-btn'

import * as UI from '@/src/(pages)/catalog/screen.styled'

import {useStore} from '@/src/shared/hooks/useStore'
import {LayoutMeta} from '@/src/shared/ui/layout/ui/meta'
import {PageTitle} from '@/src/shared/ui/layout/ui/page-title'
import {LayoutUI} from '@/src/shared/ui/layout/ui/styles'
import {BrandsCatalogContent} from '@/src/core/domain/entities/catalog/types'
import {useCatalogFiltersVisibility} from '@/src/features/catalog/filters-v2/containers/csr-filters-provider'

export const BrandsProductListMeta = observer(() => {
  const {pageData} = useStore<BrandsCatalogContent>()
  const mobile = useCatalogFiltersVisibility()

  const catalogPageTypes = [PageType.CatalogProductList, PageType.BrandProductList, PageType.CatalogSales] as const

  return (
    <LayoutUI.Meta
      as={LayoutMeta}
      title={
        <PageTitle>
          <h1>{pageData?.content.brand?.name}</h1>
          {pageData?.type &&
            catalogPageTypes.includes(pageData!.type as ArrayItem<typeof catalogPageTypes>) &&
            mobile && <UI.CatalogFiltersMobileBtn as={CatalogFiltersMobileBtn} />}
        </PageTitle>
      }
      breadcrumbs={
        (pageData?.breadcrumbs && pageData?.breadcrumbs.length > 0 && pageData?.breadcrumbs) ||
        ([{title: 'Бренды', url: Routes.brands.page}, {title: pageData?.content.brand?.name}] as BreadcrumbItem[])
      }
    />
  )
})
